import {
  IntegrationType,
  LocationAssociation,
  LocationAssociationEntityType,
} from '@kinetic-ui/data-layer';

type EntityFields = Pick<LocationAssociation, 'entityType' | 'systemEnabled' | 'integrationType'>;

export type LocationAttributes = {
  locationType: string;
  associatedEntities: EntityFields[];
};

export const isValidIntersectionLocation = (
  location: LocationAttributes | undefined,
  showDisabledSignals?: boolean
) => {
  if (!location) {
    return false;
  }
  // the location is not an Intersection type
  if (location.locationType !== 'Intersection') {
    return false;
  }
  const signalIntegration = location.associatedEntities.find(
    (i) => i.systemEnabled && i.integrationType === IntegrationType.Signal
  );
  // the location doesn't contain any enabled signal integrations
  if (!signalIntegration && !showDisabledSignals) {
    return false;
  }

  const signal = location.associatedEntities.find(
    (e) => e.entityType === LocationAssociationEntityType.SignalsIntersection
  );
  // the location doesn't have an associated signal entity
  if (!signal) {
    return false;
  }

  return true;
};
